<footer class="footer">
    <img class="footer__illu" style="height: 300px" src="{ eldritchSky }" alt="">
    <div>creato da Eldritch Café - <a href="https://github.com/EldritchCafe/radio" target="_blank">codice sorgente</a><br>adattato da Kenobit ed Ed per <a href="https://livellosegreto.it" target="_blank">Livello Segreto</a><br>loghi a cura di <a href="https://livellosegreto.it/web/@Zed" target="_blank">Zeb</a></div>
</footer>

<script>
    import eldritchSky from '/src/assets/img/lslogofooter.png'
</script>
